export enum ROLE {
    PART_TIME_STAFF = 0,
    STORE_VIEWER = 1,
    STORE = 2,
    FC = 3,
    HEAD = 4,
}
